import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { mode: { type: String, default: "date" } }

  connect() {
    if (typeof flatpickr === "undefined") return
    this.element.setAttribute("autocomplete", "off")
    this.fp = flatpickr(this.element, {
      allowInput: true,
      dateFormat: this.modeValue === "datetime" ? "Y-m-d\\TH:i" : "Y-m-d",
      enableTime: this.modeValue === "datetime",
      time_24hr: true,
    })
    // Unstyled calendars are position: static and render inline at the
    // bottom of the page; the stylesheet sets absolute. Throw (don't log)
    // so the omission reaches Sentry instead of shipping silently.
    if (getComputedStyle(this.fp.calendarContainer).position === "static") {
      throw new Error(
        'flatpickr CSS missing — the page must load the "editors" style bundle'
      )
    }
  }

  disconnect() {
    if (this.fp) {
      this.fp.destroy()
      this.fp = null
    }
  }
}
